import { render, staticRenderFns } from "./AddNft.vue?vue&type=template&id=fdbca988&scoped=true&"
import script from "./AddNft.vue?vue&type=script&lang=ts&"
export * from "./AddNft.vue?vue&type=script&lang=ts&"
import style0 from "./AddNft.vue?vue&type=style&index=0&id=fdbca988&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbca988",
  null
  
)

export default component.exports